exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".z3xNJ{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;padding:40px 50px;position:absolute;bottom:32px}._98wS2{width:84px;height:20px;line-height:20px;font-size:14px;font-weight:400;color:#a8b1b9}._3Drdb{display:-webkit-box;display:-ms-flexbox;display:flex}._2TY2B{padding-right:21px;cursor:pointer}._2TY2B:last-child{padding-right:0}._2TY2B img{width:38px;height:38px}", ""]);

// exports
exports.locals = {
	"thirdPart": "z3xNJ",
	"header": "_98wS2",
	"btnBox": "_3Drdb",
	"btn": "_2TY2B"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-rules-2!./node_modules/postcss-loader/lib??ref--1-rules-3!./src/components/p_login/ThirdLogin/index.css
// module id = 1186
// module chunks = 7